<div class="tiles-wrapper">
  <div class="tiles-content">
    <div
      class="tile-block"
      [class.disabled]="i >= tilesSize"
      *ngFor="let block of tileBlocks; let i = index"
    >
      <div
        class="tile"
        [class.active]="selectedBlock === block"
        (click)="handleBlockSelect(block, i)"
      >
        <div class="tile-in">
          <div class="tile-x" *ngFor="let x of block.size.x | toArray">
            <div
              class="tile-square"
              *ngFor="let y of block.size.y | toArray"
            ></div>
          </div>
        </div>
      </div>
      <h3 class="tile-block--title" *ngIf="block?.size as size">
        {{ size.x }}x{{ size.y }}
      </h3>
    </div>
  </div>
  <div class="cost">
    <ng-container *ngIf="prices$ | async as prices">
      <h4>Cost:</h4>
      <svg width="23" height="20" viewBox="0 0 23 20">
        <use href="#ethereum-icon" />
      </svg>
      <span>{{ prices.eth }}</span>
      <h4 class="usd">({{ prices.usd | currency: "USD":"symbol":"1.0-4" }})</h4>
    </ng-container>
  </div>
</div>
